// Painter's-algorithm depth from a sprite's ground anchor (its base/feet screen-y):
// larger y (lower on screen) → larger depth → drawn in front. Used to interleave the
// avatar with crops / budy / animals. HUD and overlays sit at UI_DEPTH, always on top.
export const UI_DEPTH = 1000;
// Name tags and hover labels: above every y-sorted body (the street sorts cars by the y of
// their wheels, which is a bigger number than any old fixed "50"), below the HUD/modals.
export const LABEL_DEPTH = 900;

export function ySortDepth(anchorY) {
  return anchorY;
}
